import { getTipByPath } from '@/lib/getTip';
export default function startLoader() {
    const tip = getTipByPath('/', { fallback: false });
    return { tip };
}
